import { AxiosError } from "axios";
import { GenericErrorResponse } from "../codegen-api";

export const unwrapApiError = (error: any) => {
  const e = error as AxiosError<GenericErrorResponse>;
  const message = e.response?.data.error || (e as Error).message;
  return message;
};
